/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */
import { jsx, css, Global, ClassNames } from '@emotion/react';
import React, { useEffect, useContext, useState } from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';
import { _Media as Media } from "../components/core/common";
import { useWorkFlow, INIT_CAPTCHA } from "../components/contexts/workflow";
import QuestionLayout from "../components/question-layout";
import QuestionProvider from "../components/question/question-context";
import EndDiagnostic from "./end";
import Header from "../components/layout/header";
import QuestionWhy from "../components/question-why";
import { _Notifications, _translate, WeverCoreContext } from "../services/core";
import Brand from "../assets/img/brand.png";
import LanguageChoice from "../components/language-choice";
import Api from "../services/api";
import Banner from "./banner";
import * as ReactDOMServer from 'react-dom/server';
import { globalStyles } from "../assets/global-css.js";
var Displayer = function Displayer() {
  var _community$dataPrivat, _community$dataPrivat2, _community$dataPrivat3, _community$dataPrivat4, _community$dataPrivat5, _community$dataPrivat6;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher,
    actions = _useWorkFlow.actions;
  var diag = collector.diag,
    currentBloc = collector.currentBloc,
    mainLoader = collector.mainLoader,
    diagId = collector.diagId;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var favicon = document.getElementById('favicon');

  // function setNativeValue(element, value) {
  //   let lastValue = element.value;
  //   element.value = value;
  //   let event = new Event('input', { target: element, bubbles: true });
  //   // React 15
  //   event.simulated = true;
  //   // React 16
  //   let tracker = element._valueTracker;
  //   if (tracker) {
  //     tracker.setValue(lastValue);
  //   }
  //   element.dispatchEvent(event);
  // }

  if (diag !== null && diag !== void 0 && diag.title && diag.title[locale]) {
    //setNativeValue(tabTitle, diag.tabTitle);
    document.title = diag.title[locale];
    if (diag.favicon) {
      Api.get(diag.favicon).then(function (value) {
        if (value.data.path.includes('https')) {
          favicon.href = value.data.path;
        } else {
          favicon.href = value.data.path.replace('http', 'https');
        }

        // expected output: "Success!"
      });
    }
  } else {
    document.title = 'wever';
  }

  //tabTitle.value = diag.tabTitle
  useEffect(function () {
    if (!diagId) {
      return;
    }
    actions.init();
  }, [diagId]);
  useEffect(function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var message = urlParams.get('error_message');
    if (message) {
      _Notifications.warning(_translate('collectorapp_warning'), _translate(message));
    }
  }, []);

  // useEffect(() => {
  //   if (collector.diagId !== 1295) {
  //     dispatcher({ type: INIT_CAPTCHA, value: true });
  //   }
  // }, [collector.initCaptcha]);

  // console.log('collector.initCaptcha', collector.initCaptcha);

  // if (!collector.initCaptcha) {
  //   return (
  //     <CaptchaValidation
  //       onValidation={(val) => {
  //         if (!val) {
  //           _Notifications.warning(
  //             _translate('collectorapp_captcha_invalid_title'),
  //             _translate('collectorapp_captcha_invalid_bot_found')
  //           );
  //           return;
  //         }

  //         dispatcher({ type: INIT_CAPTCHA, value: true });
  //       }}
  //     />
  //   );
  // }

  if ((mainLoader || !diag || !diagId) && !collector.is_finished) {
    return jsx("div", {
      className: "w-100 vh-100 d-flex justify-content-center align-items-center"
    }, jsx("span", {
      className: "d-flex justify-content-center align-items-center",
      style: {
        flexDirection: 'column'
      }
    }, jsx("img", {
      src: Brand,
      style: {
        maxWidth: '10em'
      },
      alt: "brand"
    }), jsx("br", null), jsx(Spinner, {
      color: "info"
    })));
  }
  if (collector.saved || collector.is_finished || collector.has_not_started) {
    var _diag$community;
    return jsx(EndDiagnostic, {
      finished: collector.is_finished,
      hasNotStarted: collector.has_not_started,
      alias: "_".concat((diag === null || diag === void 0 ? void 0 : diag.id) || 0, "_").concat((diag === null || diag === void 0 || (_diag$community = diag.community) === null || _diag$community === void 0 ? void 0 : _diag$community.id) || 0)
    });
  }
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null
  };
  var svgString = encodeURIComponent(ReactDOMServer.renderToStaticMarkup(jsx(Banner, {
    fill: (_community$dataPrivat = (_community$dataPrivat2 = community.dataPrivate.primaryColor) === null || _community$dataPrivat2 === void 0 ? void 0 : _community$dataPrivat2.value) !== null && _community$dataPrivat !== void 0 ? _community$dataPrivat : '#00a8d7'
  })));
  return jsx(React.Fragment, null, jsx(QuestionProvider, null, jsx("div", {
    className: "collectorContainer",
    css: globalStyles((_community$dataPrivat3 = (_community$dataPrivat4 = community.dataPrivate.primaryColor) === null || _community$dataPrivat4 === void 0 ? void 0 : _community$dataPrivat4.value) !== null && _community$dataPrivat3 !== void 0 ? _community$dataPrivat3 : '#00a8d7', (_community$dataPrivat5 = (_community$dataPrivat6 = community.dataPrivate.secondaryColor) === null || _community$dataPrivat6 === void 0 ? void 0 : _community$dataPrivat6.value) !== null && _community$dataPrivat5 !== void 0 ? _community$dataPrivat5 : '#00b6e6')
  }, jsx("div", {
    className: "banner-svg d-flex justify-content-end align-items-center",
    style: {
      backgroundImage: "url(\"data:image/svg+xml,".concat(svgString, "\")")
    }
  }, jsx(LanguageChoice, null), diag && diag.community && diag.community.logo && jsx(React.Fragment, null, jsx(Media, {
    data: diag.community.logo,
    className: "logo-community d-flex align-items-center"
  }))), jsx("div", {
    className: "collectorContent"
  }, jsx(Header, {
    blocs: diag.blocs,
    currentBloc: currentBloc
  }), jsx("div", {
    className: "collectorBody"
  }, jsx(Container, null, jsx(Row, {
    className: "justify-content-center"
  }, jsx(Col, {
    className: "align-self-center"
  }, jsx(QuestionLayout, null)), jsx(QuestionWhy, {
    content: collector.currentQuestion ? collector.currentQuestion.why : null
  }))))))));
};
export default Displayer;